export default function ErrorNotice({ message }) {
  return <div className="p-4 bg-yellow-500 mb-4">{message}</div>;
}
